/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_Page_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Error_Notfound_Heading_Page_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_page_not_found = /** @type {((inputs?: Error_Notfound_Heading_Page_Not_FoundInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_Page_Not_FoundInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seite nicht gefunden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Page introuvable")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("页面未找到")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("找不到頁面")
	if (locale === "ko") return /** @type {LocalizedString} */ ("페이지를 찾을 수 없습니다")
	return /** @type {LocalizedString} */ ("Page not found")
});